import { BASE_API_URL, ROLEANDPERMISSIONS } from '../constants';
import { AppService, HTTPHeaders } from './app.service';

const options = AppService.options();

export const roleAndPermissionsService = {
  get_permissions_data: async () => {
    const headers = HTTPHeaders();
    const reqOptions = {
      options: {
        method: 'GET',
      },
    };
    const response = await AppService.makeRequest(
      `${BASE_API_URL}${
        ROLEANDPERMISSIONS.PERMISSION_LIST
      }?teamOwnerId=${localStorage.getItem('teamOwnerId')}`,
      {
        ...reqOptions,
        ...headers,
      }
    );
    return response;
  },
  get_roles: async () => {
    const headers = HTTPHeaders();
    const reqOptions = {
      options: {
        method: 'GET',
      },
    };
    const response = await AppService.makeRequest(
      `${BASE_API_URL}${
        ROLEANDPERMISSIONS.GET_ROLES
      }?teamOwnerId=${localStorage.getItem('teamOwnerId')}`,
      {
        ...reqOptions,
        ...headers,
      }
    );
    return response;
  },
  get_role: async (data) => {
    const headers = HTTPHeaders();
    const reqOptions = {
      options: {
        method: 'GET',
      },
    };
    const response = await AppService.makeRequest(
      `${BASE_API_URL + ROLEANDPERMISSIONS.GET_ROLE}/${
        data.roleId
      }/${localStorage.getItem('teamOwnerId')}/${data.userTypeId}`,
      {
        ...reqOptions,
        ...headers,
      }
    );
    return response;
  },
  update_member_role: async (data) => {
    const headers = HTTPHeaders();
    headers.headers['Content-type'] = 'application/json';
    const response = await AppService.makeRequest(
      BASE_API_URL + ROLEANDPERMISSIONS.UPDATE_MEMBER_ROLE,
      {
        ...options,
        ...headers,
        body: JSON.stringify(data),
      }
    );
    return response;
  },
  create_role: async (data) => {
    const headers = HTTPHeaders();
    headers.headers['Content-type'] = 'application/json';
    const response = await AppService.makeRequest(
      BASE_API_URL + ROLEANDPERMISSIONS.CREATE_ROLE,
      {
        ...options,
        ...headers,
        body: JSON.stringify(data),
      }
    );
    return response;
  },
  update_role: async (data) => {
    const headers = HTTPHeaders();
    headers.headers['Content-type'] = 'application/json';
    const reqOptions = {
      method: 'PUT',
    };
    const response = await AppService.makeRequest(
      BASE_API_URL + ROLEANDPERMISSIONS.UPDATE_ROLE,
      {
        ...reqOptions,
        ...headers,
        body: JSON.stringify(data),
      }
    );
    return response;
  },
  delete_role: async (roleId) => {
    const headers = HTTPHeaders();
    headers.headers['Content-type'] = 'application/json';
    const reqOptions = {
      method: 'DELETE',
    };
    const response = await AppService.makeRequest(
      `${BASE_API_URL + ROLEANDPERMISSIONS.DELETE_ROLE}/${localStorage.getItem(
        'teamOwnerId'
      )}/${roleId}`,
      {
        ...reqOptions,
        ...headers,
      }
    );
    return response;
  },
  get_default_permissions: async () => {
    const headers = HTTPHeaders();
    const reqOptions = {
      options: {
        method: 'GET',
      },
    };
    const response = await AppService.makeRequest(
      `${BASE_API_URL}${
        ROLEANDPERMISSIONS.DEFAULT_ROLE
      }?teamOwnerId=${localStorage.getItem('teamOwnerId')}`,
      {
        ...reqOptions,
        ...headers,
      }
    );
    return response;
  },
  remove_member_role: async (data) => {
    const headers = HTTPHeaders();
    headers.headers['Content-type'] = 'application/json';
    const response = await AppService.makeRequest(
      BASE_API_URL + ROLEANDPERMISSIONS.REMOVE_MEMBER_ROLE,
      {
        ...options,
        ...headers,
        body: JSON.stringify(data),
      }
    );
    return response;
  },
  get_user_types: async () => {
    const headers = HTTPHeaders();
    const reqOptions = {
      options: {
        method: 'GET',
      },
    };
    const response = await AppService.makeRequest(
      `${BASE_API_URL}${
        ROLEANDPERMISSIONS.GET_USER_TYPES
      }?teamOwnerId=${localStorage.getItem('teamOwnerId')}`,
      {
        ...reqOptions,
        ...headers,
      }
    );
    return response;
  },
};
